const intlCache: Record<string, Intl.NumberFormat> = {};

export function formatCurrency({
  currency,
  amount,
}: {
  currency: string;
  amount: number | { toNumber: () => number }; // Stand in for a Decimal interface
}): string {
  let formatter = intlCache[currency];

  if (!formatter) {
    formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency });
    intlCache[currency] = formatter;
  }

  return formatter.format(
    typeof amount === 'number' ? amount : amount.toNumber()
  );
}
